export const OpenLinkedInIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 17 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.75 10C13.1562 10 13.5 10.3438 13.5 10.75V14.25C13.5 15.2188 12.6875 16 11.75 16H2.25C1.28125 16 0.5 15.2188 0.5 14.25V4.75C0.5 3.8125 1.28125 3 2.25 3H5.75C6.15625 3 6.5 3.34375 6.5 3.75C6.5 4.1875 6.15625 4.5 5.75 4.5H2.25C2.09375 4.5 2 4.625 2 4.75V14.25C2 14.4062 2.09375 14.5 2.25 14.5H11.75C11.875 14.5 12 14.4062 12 14.25V10.75C12 10.3438 12.3125 10 12.75 10ZM15.75 0C16.1562 0 16.5 0.34375 16.5 0.75V6C16.5 6.4375 16.1562 6.75 15.75 6.75C15.3125 6.75 15 6.4375 15 6V2.5625L7.25 10.2812C7.125 10.4375 6.9375 10.5 6.75 10.5C6.53125 10.5 6.34375 10.4375 6.21875 10.2812C5.90625 10 5.90625 9.53125 6.21875 9.21875L13.9375 1.5H10.5C10.0625 1.5 9.75 1.1875 9.75 0.75C9.75 0.34375 10.0625 0 10.5 0H15.75Z"
      fill="currentColor"
    />
  </svg>)